import request from '@/api/request.js'

// 新增
export function LinkCategoryInsert(data) {
    return request({
        url: '/api/link/linkcategoryinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function LinkCategoryDelete(id) {
    return request({
        url: `/api/link/linkcategorydelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function LinkCategoryUpdate(id, data) {
    return request({
        url: `/api/link/linkcategoryupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function LinkCategoryGetById(id) {
    return request({
        url: `/api/link/getlinkcategorybyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function LinkCategoryGetList(params) {
    return request({
        url: '/api/link/getlinkcategorylist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function LinkCategoryGetPageList(params) {
    return request({
        url: '/api/link/getlinkcategorypagelist',
        method: 'get',
        params: params
    })
}